import React from 'react';
import { isAdminLoggedIn } from '../../../controller/localStroageHandler';
import { Navigate } from 'react-router-dom';
import routes from '../../../controller/Routes';

const AdminPublicRoute = ({ children }) => {
  return isAdminLoggedIn() ? (
    <Navigate to={routes.admin.dashboard.candidates} />
  ) : (
    children
  );
};

export default AdminPublicRoute;
